import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import ReactQuill from 'react-quill';  // Quill editor
import 'react-quill/dist/quill.snow.css';  // Quill styles
import axios from 'axios';

const Modifier_diffusion = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { listediffusion_id } = location.state || {}; // Récupérer l'ID de la diffusion à modifier
    const navigate = useNavigate(); // Fonction de redirection

    const [diffusionData, setDiffusionData] = useState({
        nom: '',
        description: '',
        statut: 'inactif',  // Initialisation du statut
    });
    const [originalDiffusionData, setOriginalDiffusionData] = useState({}); // Stockage des données originales

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Modifier Liste de diffusion";
      }
    }, [user_id]);

    // Récupérer les données de la diffusion pour les afficher dans le formulaire
    useEffect(() => {
        const fetchDiffusionData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/liste-diffusion-info/${listediffusion_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setDiffusionData({
                        nom: data.nom,
                        description: data.description,
                        statut: data.statut,
                    });
                    setOriginalDiffusionData({  // Stocker les données originales pour réinitialisation
                        nom: data.nom,
                        description: data.description,
                        statut: data.statut,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données de la diffusion');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchDiffusionData();
    }, [listediffusion_id]);


    // Fonction de soumission du formulaire
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = {
            nom: diffusionData.nom,
            description: diffusionData.description,
            statut: diffusionData.statut,
        };
    
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-liste-diffusion/${listediffusion_id}/`, {
                method: 'PUT', // Utilisation de PUT pour modifier la diffusion
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                navigate(`/Liste-diffusion`);  // Redirection vers la liste des diffusions après modification
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };
    

    // Fonction pour réinitialiser les champs à leur état original
    const handleCancel = () => {
        setDiffusionData(originalDiffusionData); // Réinitialisation des données
    };

    // Configuration des modules Quill (barre d'outils)
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("ListeDeDiffusion")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="mb-1"><i className="fa fa-rss"></i> Modification de la diffusion {originalDiffusionData.nom}</h2>
                            <small>Administration des diffusions.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-diffusion`}>Diffusions</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Modification du Diffusion {originalDiffusionData.nom}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid">
                        {/* Row principale qui centre le contenu */}
                        <div className="row justify-content-center">
                            {/* Colonne avec des classes responsive */}
                            <div className="col-12 col-lg-8 mx-auto mt-5 mb-3">
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                                {/* Formulaire pour le nom */}
                                                <div className="form-group">
                                                    <label>Nom*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="nom"
                                                        value={diffusionData.nom || ''}
                                                        onChange={(e) => setDiffusionData({ ...diffusionData, nom: e.target.value })}
                                                    />
                                                </div>

                                                {/* Formulaire pour la description avec Quill */}
                                                <div className="form-group">
                                                <label>Description</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="description"
                                                        value={diffusionData.description || ''}
                                                        onChange={(e) => setDiffusionData({ ...diffusionData, description: e.target.value })}
                                                    />
                                                </div>

                                                {/* Sélecteur pour le statut */}
                                                <div className="form-group">
                                                    <label>Statut*</label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="statut"
                                                        value={diffusionData.statut || 'inactif'}
                                                        onChange={(e) => setDiffusionData({ ...diffusionData, statut: e.target.value })}
                                                    >
                                                        <option value="inactif">Inactif</option>
                                                        <option value="actif">Actif</option>
                                                    </select>
                                                </div>

                                                {/* Boutons d'action */}
                                                <div className="text-center mt-4">
                                                    <a href='/Liste-diffusion' className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Modifier_diffusion;